import { observable, action, makeObservable } from 'mobx';
import { Stomp, CompatClient } from '@stomp/stompjs';
import { message } from 'antd';
import { RecordMessage } from '@/types/record';
import { elkLog, elkReport } from '@/utils/elkReport';

const REDELAY = 5000;

/*
stormp消息模板

{
  "timestamp": 1659519138285,
  "channelId": 1345078002763746,
  "jobSerialId": 30779,
  "sentences": [
  {
    "sentence": "Why am harry",
    "sentenceType": 2,
    "sentenceIndex": 111,
    "speakerMemberUid": "zhuwenxu@corp.netease.com",
    "speakerDeviceId": "ed6a61f8ad21bd726f153a7289f6d65a",
    "speakerYxUid": 520015
  }
]
}
*/

export function stompMsgToRecordMsg(stmopMsg: any): RecordMessage {
  return {
    timestamp: stmopMsg?.timestamp,
    subtitleContent: stmopMsg.sentences?.[0]?.sentence || '',
    id: stmopMsg.sentences?.[0]?.speakerYxUid + stmopMsg?.timestamp?.toString(),
    name: stmopMsg.sentences?.[0]?.speakerMemberUid,
    url: '',
    yxuid: stmopMsg.sentences?.[0]?.speakerYxUid,
    sentenceType: stmopMsg.sentences?.[0]?.sentenceType,
    uid: stmopMsg.sentences?.[0]?.speakerMemberUid,
  };
}

class StompInstance {
  constructor() {
    makeObservable(this);
  }

  @observable startedConnected = false;

  @observable connected = false;

  @observable client: CompatClient | null = null;

  @observable startConnect: boolean = false;
  @observable responseBody: {
    data: {
      body: string;
      commandId: number;
      channelId: number;
      sender: string;
      serviceId: number;
      timestamp: number;
    };
  } | null = null;

  @action
  setStartedConnected(linked: boolean) {
    this.startedConnected = linked;
  }

  @action
  stompConnect(url: string, sbuString: string) {
    this.client = Stomp.client(url);
    // const urlObj = new URL(url);
    // this.client = Stomp.client(url?.replace(urlObj.origin, 'ws://10.219.152.59:10012'));
    elkLog('pc转录', { dataType: 'stompConnect' }, { url });
    this.client.reconnect_delay = REDELAY;

    let heartbeatTimer: number;
    const heartbeat = () => {
      heartbeatTimer && window.clearInterval(heartbeatTimer);
      heartbeatTimer = window.setInterval(() => {
        this.client?.publish({
          destination: `/heart-beat`,
        });
      }, 30 * 1000);
    };
    const successCallback = () => {
      if (!this.client) return;
      // 连接成功时（服务器响应 CONNECTED 帧）的回调方法
      this.client.subscribe(sbuString, (response) => {
        this.responseBody = JSON.parse(response.body);
        console.log(JSON.parse(response.body), '客户端转录stomp response', url, sbuString);
      });
      this.connected = true;
      heartbeat();
      elkLog('pc转录', { dataType: 'stompSubscribe' }, { sbuString });
    };
    const errorCallback = () => {
      // 连接失败时（服务器响应 CONNECTED 帧）的回调方法
      // eslint-disable-next-line no-use-before-define
      setTimeout(connect, REDELAY);
    };
    const closeCallback = (e: any) => {
      heartbeatTimer && window.clearInterval(heartbeatTimer);
      this.client = null;
      return e;
    };
    // 向服务器发起websocket连接并发送CONNECT帧
    const connect = () => {
      this.client?.connect({ deviceType: 'web' }, successCallback, errorCallback, closeCallback);
    };
    connect();
  }

  @action
  async connect({
    channelId,
    language,
    translateTargetLanguage,
    ableChangeLanguage,
  }: {
    channelId: number;
    language: string;
    translateTargetLanguage: string;
    ableChangeLanguage: boolean;
  }) {
    if (!channelId || this.startConnect) return;
    if (this.client) {
      await this.client.disconnect();
    }
    if (ableChangeLanguage) {
      this.startConnect = true;
      await API.client.meetingSubtitleV3.switchTranscriptionLanguage
        .request(
          {},
          {
            channelId,
            language,
            translateTargetLanguage,
            translate: !!translateTargetLanguage,
          }
        )
        .then((res) => {
          switch (res.status) {
            case 1:
              if (res.data) {
                const { stompDestination, stompEndpoint } = res.data;
                this.stompConnect(stompEndpoint, stompDestination);
              } else {
                message.error(res.message);
              }
              break;
            case 650001:
              break;
            default:
              message.error(res.message);
          }
          elkLog(
            'pc转录',
            { dataType: 'api', apiType: 'switchTranscriptionLanguage' },
            {
              req: {
                channelId,
                language,
                translateTargetLanguage,
                translate: !!translateTargetLanguage,
              },
              res,
            }
          );
          this.startConnect = false;
        });
    } else {
      this.startConnect = true;
      await API.client.meetingSubtitleV3.getStompAuth.request({ channelId }).then((res) => {
        switch (res.status) {
          case 1:
            if (res.data) {
              const { stompDestination, stompEndpoint } = res.data;
              this.stompConnect(stompEndpoint, stompDestination);
            } else {
              message.error(res.message);
            }
            break;
          case 650001:
            break;
          default:
            message.error(res.message);
        }
        elkLog(
          'pc转录',
          { dataType: 'api', apiType: 'getStompAuth' },
          {
            req: {
              channelId,
              language,
              translateTargetLanguage,
              translate: !!translateTargetLanguage,
            },
            res,
          }
        );
        this.startConnect = false;
      });
    }
  }

  @action
  disconnect() {
    if (!this.client) return;
    this.client.disconnect(() => {
      this.client = null;
    });
  }
}

export default StompInstance;
